import React, {useContext} from "react"
import { graphql } from 'gatsby'
import Layout from "../components/layout"
import Video from '../components/Video/Video'
import BeanoPageBody from "../components/ParentHome/BeanoPageBody"
import BannerImage from './../images/banner-beano.png'


export const parentHomePage = graphql`  query ParentBeanoPage {
	prismicEepsParentHomepage {
		data {
			title
			hero_video {
				document {
					... on PrismicEepsYoutubeVideo {
						id
						data {
							display_transcript
							transcript_details
							video_id
							image {
								alt
								localFile {
									...videoImage
								}
							}
						}
					}
				}
			}
			related_articles {
				document {
					... on PrismicEepsRelatedArticles {
						id
						data {
							name
							related_articles {
								article {
									document {
										... on PrismicEepsArticleV2 {
											uid
											data {
												title
												short_description
												related_section_title
												internet_matters_article
												hero_image {
													localFile {
														...articleCardImage
														...heroBannerImage
													}
													alt
												}
											}
										}
									}
								}
							}
						}
					}
				}
			}
			get_phonesmart_banner {
				document {
					... on PrismicEepsCtaBanner {
						id
						data {
							banner_description
							banner_sub_title
							banner_title
							primary_cta_label
							primary_cta_link
							secondary_link
							secondary_link_label
						}
					}
				}
			}
			partners {
				partner {
					document {
						...partnerInfo
					}
				}
			}
		}
	}
}`

// markup
const IndexPage = ({data}) => {
	console.log(data)
	return (
	<Layout title="Beano" headerStyle="beano">
		{/* <Video data={data.prismicEepsParentHomepage.data.hero_video.document.data} engagement={"Grown-up Homepage"}/> */}
		<BeanoPageBody data={data.prismicEepsParentHomepage.data} engagement={"Grown-up Homepage"}/>
	</Layout>
	)
}

export default IndexPage
